import SearchableSelect from "./SearchableSelect";
import { normalizeSelectOptions } from "../utils/selectOptions";

export default function SelectField({ options, value, onChange, label, disabled = false, searchable = false, placeholder, searchPlaceholder }) {
  const normalized = normalizeSelectOptions(options);
  if (searchable) return <SearchableSelect options={normalized} value={value} onChange={onChange} ariaLabel={label} disabled={disabled} placeholder={placeholder} searchPlaceholder={searchPlaceholder} />;
  return (
    <select className="ib-select" aria-label={label} disabled={disabled} value={value} onChange={(event) => onChange(event.target.value)}>
      {normalized.map((option) => <option key={option.value} value={option.value} disabled={option.disabled}>{option.label}</option>)}
    </select>
  );
}
